import React, { useEffect, useState } from 'react';
import axios from 'axios';

const obtenerPrecioAccion = async (ticker) => {
  try {
    const respuesta = await axios.get(`https://southamerica-east1-prueba-functions-9b36e.cloudfunctions.net/get-Price-API?symbol=${ticker}`);

    if (respuesta.status !== 200) {
      throw new Error('Error al obtener el precio de la acción');
    }

    return respuesta.data.precio;
  } catch (error) {
    throw new Error(error.message);
  }
};

const Prueba = () => {
  const [precioAccion, setPrecioAccion] = useState(null);

  useEffect(() => {
    const ticker = 'AAPL';
    obtenerPrecioAccion(ticker)
      .then((precio) => {
        console.log('Precio de la acción:', precio);
        setPrecioAccion(precio);
      })
      .catch((error) => console.error('Error al obtener el precio:', error.message));
  }, []);

  return (
    <div>
      {precioAccion !== null ? (
        <p>El precio de la acción es: {precioAccion}</p>
      ) : (
        <p>Cargando...</p>
      )}
    </div>
  );
};

export default Prueba;